module.exports = __webpack_public_path__ + "img/crm-home.7dffbe52.svg";